// ============================================================================
// src/app/navigation/reactRouterDriver.ts — the react-router navigation driver.
// ============================================================================
// The CURRENT router, expressed as one adapter behind the router-neutral
// driver contract (navigationDriver.js). Nothing outside this directory may
// import this file; consumers use the facade barrel, and the future root join
// registers a driver explicitly (see the root-join manifest in
// navigationDriver.js).
// ============================================================================

import {Link, useLocation, useNavigate} from 'react-router-dom';

export const reactRouterDriver = Object.freeze({
  name: 'react-router-dom@7',
  useNavigateFn: useNavigate,
  useLocationValue: useLocation,
  LinkComponent: Link,
});
